import {types} from './types';

const setGroupsAction = (payload) => {
    return {
        type: types.SET_GROUPS,
        payload,
      }
}

const setGroupsViewAction = (payload) => {
  return {
      type: types.SET_GROUPS_VIEW,
      payload,
    }
}

const setGetEventHistoryListAction = (payload) => {
  return {
    type: types.SET_GET_EVENT_HISTORY,
    payload
  }
}

const setGetGamerListAction = (payload) => {
  return {
    type: types.SET_GAMER_LIST,
    payload
  }
}

const setGetBetAction = (payload) => {
  return {
    type: types.SET_BET,
    payload
  }
}

const setGetOperatorDetalizationAction = (payload) => {
  return {
    type: types.SET_OPERATOR_DETALIZATION,
    payload
  }
}

const setGetGamerInformationAction = (payload) => {
  return {
    type: types.SET_COUNT_GAMER,
    payload
  }
}

const setGetCreditHistoryAction = (payload) => {
  return {
      type: types.SET_LIST_CREDIT_HISTORY,
      payload,
    }
}

export {
  setGroupsAction,
  setGroupsViewAction,
  setGetEventHistoryListAction,
  setGetGamerListAction,
  setGetBetAction,
  setGetOperatorDetalizationAction,
  setGetGamerInformationAction,
  setGetCreditHistoryAction
}